import React from "react";
import { HeroSection } from "../../shared/components";

export default function Home() {
  return (
    <div className="min-h-screen flex flex-col">
      <HeroSection />
    </div>
  );
}
